module.exports = __webpack_public_path__ + "img/vrbo.cb74cb09.svg";